import { Person } from 'entities/person';
import { FC } from 'react';
import { Flex } from 'shared/ui/flex';
import { MessageIcon } from 'shared/ui/icons/message';

export const PersonNotesMarker: FC<{ person: Person }> = ({ person }) => {
	return (
		<Flex $justify="flex-end" $cursor="pointer">
			{person.notes.length > 0 ? <MessageIcon /> : <></>}
		</Flex>
	);
};
